import { render, staticRenderFns } from "./ContainerTypeBadge.vue?vue&type=template&id=97e82f50&scoped=true"
import script from "./ContainerTypeBadge.vue?vue&type=script&lang=ts"
export * from "./ContainerTypeBadge.vue?vue&type=script&lang=ts"
import style0 from "./ContainerTypeBadge.vue?vue&type=style&index=0&id=97e82f50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e82f50",
  null
  
)

export default component.exports